<template>
    <div class="app">
        <TopNav></TopNav>
        <div class="center">
            <div class="news1-hd">
            </div>
            <div class="news1-hd-top">
                <div class="content_row">
                    <h2>2022中央一号文件来了！</h2>
                    <p class="news1-hd-box1">
                        2022年中央一号文件于2月22日正式发布。这份文件题为《中共中央国务院关于做好2022年全面推进乡村振兴重点工作的意见》，这是21世纪以来第19个指导“三农”工作的中央一号文件。
                    </p>
                    <img src="../../assets/news-1-1.jpg" alt="">

                    <p>文件提出，牢牢守住保障国家粮食安全和不发生规模性返贫两条底线，突出年度性任务、针对性举措、实效性导向，充分发挥农村基层党组织领导作用，扎实有序做好乡村发展、乡村建设、乡村治理重点工作，推动乡村振兴取得新进展、农业农村现代化迈出新步伐。
                    </p>

                    <p>文件还指出，大力推进数字乡村建设，推进智慧农业发展，促进信息技术与农机农艺融合应用，以数字技术赋能乡村公共服务，推动“互联网+政务服务”向乡村延伸覆盖等。</p>

                    <p>这些年，国家持续深化关注农业，不断释放相关政策利好，提振发展信心，推进行业快速发展，为保障国家粮食安全、全面推进乡村振兴、实现农业农村现代化提供有力支撑。</p>

                    <p>智慧农贸市场的建设，为政府（监管单位）解决了食品安全中的所有流通环节，为食品安全追溯提供了有力的监管；为农贸市场解决了交易数据实时呈现，积累大数据后为经营换了决策提供依据；为消费者提供了一个放心、安全、便捷的购物场所；为智慧农业的发展，数字乡村的建设，乡村振兴的实施起着至关重要的推动作用。
                    </p>

                </div>
            </div>
        </div>
        <BottomNav></BottomNav>
    </div>
</template>

<script>
import TopNav from '../../components/TopNav.vue'
import BottomNav from '../../components/BottomNav.vue'
export default {
    components: { TopNav, BottomNav },
    data() {
        return {

        }
    },
    created() { },
    mounted() {

    },
    methods: {},
}
</script>

<style lang="less" scoped>
.app {
    width: 100vw;
    height: 100vh;
    background-size: cover;
    z-index: -1;
    overflow-x: hidden;
}

.center {
    width: 100%;
    min-height: calc(100vh - .8333rem - 5.9063rem);
    margin-top: .8333rem;
    overflow: hidden;
}

.content_row {
    width: 100%;
    height: 100%;
    padding: 0 4.25rem;
    box-sizing: border-box;
}

.title_content {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.title_content .title {
    display: flex;
    align-items: center;
}

.title_content img {
    width: 1.1458rem;
    height: .2292rem;
}

.title_content h1 {
    font-size: .3958rem;
}

.title_content p {
    height: .3021rem;
    font-size: .2188rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #232A24;
    line-height: .3021rem;
    margin-top: .2917rem;
}

.news1-hd {
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 5.2083rem;
    background: url(../../assets/news-bj.png) no-repeat center;
    background-size: 100% 5.2083rem;
    margin-top: .8333rem;
    z-index: -1;
    margin-bottom: .3125rem;
}

.news1-hd-top {
    height: 18.25rem;
    text-align: center;
}

.news1-hd-top h2 {
    width: 100%;
    height: .5208rem;
    line-height: .5208rem;
    text-align: center;
    color: #000;
    font-size: .3333rem;
    margin-bottom: .5208rem;
}

.news1-hd-top .news1-hd-box1 {
    text-align: center;
    font-size: .2083rem;
    line-height: .2604rem;
    color: rgb(194, 79, 74);
    margin-bottom: .3125rem;
}

.news1-hd-top img {
    width: 6.6667rem;
    height: 10rem;
    margin-bottom: .5rem;
}

.news1-hd-top p {
    text-indent: 2em;
    margin-bottom: .25rem;
    font-size: .2283rem;
    line-height: .3604rem;
    text-align: left;
}
</style>